<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="row">
          <div class="col-md-12">
            <div class="top-list-toolbar">
              <h4 class="text-primary">Rekening Bank</h4>
              <ol class="breadcrumb breadcrumb-card-header">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0);" @click="backParent">Rekening Bank</a>
                </li>
                <li class="breadcrumb-item active">
                  <span v-if="ledger.id === null">New</span>
                </li>
              </ol>
              <div>
                <button type="button" class="btn btn-sm btn-hard-outline-primary pull-left" @click="backParent">
                  <i class="fa fa-chevron-circle-left" aria-hidden="true"></i> Back
                </button>
                <button type="button" @click="saveLedger" class="btn btn-sm btn-soft-primary pull-left" v-if="ledger.id === null">Save</button>
                <button type="button" @click="updateLedger('reply')" class="btn btn-sm btn-soft-primary pull-left" v-else>Update</button>
                <button type="button" @click="removeLedger" class="btn btn-sm btn-danger pull-left">Delete</button>
              </div>
            </div>
          </div>
      </div>

      <div class="card card-list">
        <div class="card-header">
          <h5>Rekening Bank</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <h5>Journal</h5>
              <table class="table table-sm table-item table-hover table-striped">
                <thead>
                  <th>Journal Code</th>
                  <th>Date</th>
                  <th>Account</th>
                  <th>Debit</th>
                  <th>Credit</th>
                  <th>Ledger ID</th>
                  <th>#</th>
                </thead>
                <tbody>
                  <tr v-for="d in ledger.journals" :key="d.id">
                    <td>{{ d.journal_code }}</td>
                    <td>{{ d.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                    <td><b>{{ d.account_code }}</b> {{ d.account }}</td>
                    <td>{{ d.debit | currency }}</td>
                    <td>{{ d.credit | currency }}</td>
                    <td>{{ d.ledger_id }}</td>
                    <td>
                      <button class="btn btn-sm btn-soft-primary"><i class="fa fa-share" aria-hidden="true"></i></button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6">
              <h5>Ledger</h5>
              <table class="table table-sm table-item table-hover table-striped">
                <thead>
                  <th>Journal Code</th>
                  <th>Date</th>
                  <th>Account</th>
                  <th>Debit</th>
                  <th>Credit</th>
                  <th>Ledger ID</th>
                  <th>#</th>
                </thead>
                <tbody>
                  <tr v-for="d in ledger.details" :key="d.id">
                    <td>{{ d.journal_code }}</td>
                    <td>{{ d.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                    <td><b>{{ d.account_code }}</b> {{ d.account }}</td>
                    <td>{{ d.debit | currency }}</td>
                    <td>{{ d.credit | currency }}</td>
                    <td>{{ d.ledger_id }}</td>
                    <td>
                      <button class="btn btn-sm btn-hard-primary"><i class="fa fa-reply" aria-hidden="true"></i></button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <pre>{{ ledger }}</pre>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { ledgerUrl, getHeader } from '../../config'
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'LedgerBankForm',
  props: ['ledger'],
  components: {
    Loading
  },
  data () {
    return {
      alert: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: false,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  computed: {
    ...mapState({
      bankList: state => state.banks.bankList,
      authUser: state => state.users.authUser,
      accountList: state => state.accounts.accountList,
      companyList: state => state.companies.companyList
    }),
    accountSelect: function () {
      var loop = []
      var array = this.accountList
      for (var x = 0; x < array.length; x++) {
        var obj = {
          account: array[x].account_code + ' - ' + array[x].account_name,
          meta: {
            code: array[x].account_code
          }
        }
        loop.push(obj)
      }
      return loop
    }
  },
  methods: {
    async checkDate () {
      return true
    },
    removeLedger: function () {
      this.$swal.fire({
        title: 'Are you sure Delete this?',
        text: "You won't be able to revert this",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!!'
      }).then((result) => {
        if (result.value) {
          axios.delete(ledgerUrl + '/' + this.ledger.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.data)
              this.$swal('Successfully', response.data.message, 'success')
            })
            .catch(error => {
              console.log(error.response)
            })
        }
      })
    },
    validate () {
      var debit = this.ledger.debit.replace(/\./g, '')
      var credit = this.ledger.credit.replace(/\./g, '')
      if (parseFloat(credit) === 0 || parseFloat(debit) === 0) {
        this.alert.push(['Debit / Credit tidak boleh kosong'])
      }
    },
    async saveLedger () {
      this.validate()
      if (this.alert.length > 0) {
        this.$swal('Error', 'Data belum valid', 'error')
        return false
      }
      this.$Progress.start()
      this.loader.isLoading = true
      var body = {
        bank_id: this.ledger.bank_id,
        date: this.ledger.date,
        notes: this.ledger.notes,
        debit: this.ledger.debit.replace(/\./g, ''),
        credit: this.ledger.credit.replace(/\./g, ''),
        parent_id: this.ledger.parent_id,
        status: 'approve',
        lock: true,
        template_id: null,
        company_no: this.ledger.company_no
      }
      await axios.post(ledgerUrl, body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          this.$Progress.fail()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async updateCash () {
      this.validate()
      if (this.alert.length > 0) {
        this.$swal('Error', 'Data belum valid', 'error')
        return false
      }
      this.$Progress.start()
      this.loader.isLoading = true
      var body = {
        id: this.ledger.id,
        bank_id: this.ledger.bank_id,
        date: this.ledger.date,
        notes: this.ledger.notes,
        debit: this.ledger.debit.replace(/\./g, ''),
        credit: this.ledger.credit.replace(/\./g, ''),
        parent_id: this.ledger.parent_id,
        status: 'approve',
        lock: true,
        template_id: null,
        company_no: this.ledger.company_no
      }
      await axios.post(ledgerUrl, body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          this.$Progress.fail()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    backParent: function () {
      this.$emit('backClicked')
    },
    addLine: function () {
      var obj = {
        cash_no: this.cash.cash_no,
        cash_date: this.cash.cash_date,
        branch_no: this.cash.branch_no,
        company_no: this.cash.company_no,
        method_id: 1,
        bank_id: null,
        tax_id: null,
        tax: 0,
        amount: '0',
        total: '0',
        description: null,
        memo_no: null,
        type: 'outcome',
        total_journal: '0'
      }
      this.cash.details.push(obj)
    }
  }
}
</script>
